import { css } from '@emotion/react'
import _uniqueId from 'lodash/uniqueId'

type TableHeaderProps = {
	datas: DataType[]
}

type DataType = {
	value: string
	width: number
	align?: 'center' | 'left' | 'right' | 'justify' | 'char'
}

const TableHeader = ({ datas }: TableHeaderProps) => {
	return (
		<thead>
			<tr>
				{datas.map(({ value, width, align = 'center' }) => (
					<th key={_uniqueId('th_')} css={tableHeader(width)} align={align}>
						{value}
					</th>
				))}
			</tr>
		</thead>
	)
}

const tableHeader = (width: number) => css`
	font-style: normal;
	font-weight: 500;
	font-size: 1.4rem;
	line-height: 1.9rem;
	letter-spacing: 0.2px;
	color: #353d4a;
	background: #f1f2f6;
	border: 1px solid #c4c4c4;
	padding: 1rem 0;
	min-width: ${width}rem;
	max-width: ${width}rem;
	border-collapse: collapse;
`

export default TableHeader
